export default __webpack_public_path__ + "static/cabin2-1f46cb8b45aa36303081e9ef030c116b.jpg";